module.exports = __webpack_public_path__ + "static/media/ic_scann_out.fb25f206.svg";